import { Icon, IconProps } from './Icon';

interface WorkTravelIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const WorkTravelIcon = ({ color = '#BDC9EE', gradient, ...props }: WorkTravelIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 45 45"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.42794 7.42456C4.81412 7.42456 3.50586 8.73282 3.50586 10.3466V18.4602L21.5854 29.5011C22.0062 29.7581 22.5353 29.7581 22.9561 29.5011L41.3561 18.2645V10.3466C41.3561 8.73282 40.0478 7.42456 38.434 7.42456H6.42794ZM41.3561 22.0307L24.6313 32.2443C23.182 33.1294 21.3594 33.1294 19.9102 32.2443L3.50586 22.2264V34.6544C3.50586 36.2682 4.81412 37.5764 6.42794 37.5764H38.434C40.0478 37.5764 41.3561 36.2682 41.3561 34.6544V22.0307Z"
      fill={gradient ? `url(#${gradient.id})` : color}
    />
  </Icon>
);
